'use client';

import { ELanguage } from '../Utils/constants.js';
import { DEFAULT_ALLOW_EXT } from './const.js';

var hrefWowCV = function (_a) {
    var source = _a.source, langCode = _a.langCode, baseUrl = _a.baseUrl;
    return "".concat(baseUrl, "/wowcv").concat(langCode === ELanguage.EN ? '/en' : '', "?utm_medium_navi=popup_apply_v2&utm_source_navi=").concat(source);
};
var formatDateTime = function (timestamp, type) {
    if (timestamp === 0)
        return '';
    var date = new Date(timestamp * 1000);
    var rawDay = date.getUTCDate();
    var rawMonth = date.getUTCMonth() + 1;
    var day = rawDay < 10 ? "0".concat(rawDay) : rawDay;
    var month = rawMonth < 10 ? "0".concat(rawMonth) : rawMonth;
    var rawHours = date.getUTCHours();
    var rawMinutes = date.getUTCMinutes();
    var hours = rawHours >= 10 ? rawHours : "0".concat(rawHours);
    var minutes = rawMinutes >= 10 ? rawMinutes : "0".concat(rawMinutes);
    switch (type) {
        case 'DDMMYYYY-HH:MM':
            return day + '/' + month + '/' + date.getUTCFullYear() + ' - ' + hours + ':' + minutes;
        case 'DDMMYYYY':
            return day + '/' + month + '/' + date.getUTCFullYear();
        default:
            return '';
    }
};
var dateToString = function (dateTime, format) {
    if (format === void 0) { format = 'DD/MM/YYYY'; }
    var date;
    if (!dateTime) {
        date = new Date();
    }
    else {
        date = new Date(typeof dateTime === 'number' ? dateTime * 1000 : dateTime);
    }
    var rawDay = date.getUTCDate();
    var rawMonth = date.getUTCMonth() + 1;
    var day = rawDay < 10 ? "0".concat(rawDay) : rawDay;
    var month = rawMonth < 10 ? "0".concat(rawMonth) : rawMonth;
    var rawHours = date.getUTCHours();
    var rawMinutes = date.getUTCMinutes();
    var hours = rawHours >= 10 ? rawHours : "0".concat(rawHours);
    var minutes = rawMinutes >= 10 ? rawMinutes : "0".concat(rawMinutes);
    switch (format) {
        case 'DD/MM/YYYY HH:MM':
            return day + '/' + month + '/' + date.getUTCFullYear() + ' ' + hours + ':' + minutes;
        case 'DD/MM/YYYY':
            return day + '/' + month + '/' + date.getUTCFullYear();
        default:
            return day + '-' + month + '-' + date.getUTCFullYear() + ' ' + hours + ':' + minutes + ':' + date.getSeconds();
    }
};
var fileName = function (fileName, maxLength) {
    if (maxLength === void 0) { maxLength = 15; }
    var name = '';
    var matchExt = '';
    // Find extension in filename
    DEFAULT_ALLOW_EXT.map(function (extension) {
        if (fileName.indexOf(extension) > 0) {
            // Match
            matchExt = extension;
        }
    });
    var fileNameWithoutMatchExt = fileName.replace(matchExt, '');
    if (fileNameWithoutMatchExt.length > maxLength) {
        name = "".concat(fileNameWithoutMatchExt.slice(0, maxLength), "..");
    }
    else {
        name = fileNameWithoutMatchExt;
    }
    return "".concat(name).concat(matchExt);
};

export { dateToString, fileName, formatDateTime, hrefWowCV };
//# sourceMappingURL=helper.js.map
